<script setup>
import AppSwiper from '#/general/AppSwiper'
import GeneralCard from 'components/general/GeneralCard.vue'
import { inject } from 'vue'

const { screen } = inject('Shared')
defineProps({
  references: Array
})
</script>

<template lang="pug">
app-swiper.references-swiper(
  :items="references"
  :slides-per-view="screen.gt.sm ? 3 : 1.2"
  :space-between="screen.gt.sm ? 37 : 24"
  :loop="false"
)
  template(#item="props")
    general-card(
      :url="`/referenzen/${props.item.url}`"
      :img="props.item.teaserImg"
      :title="props.item.teaserHeadline"
      :subtitle="props.item.teaserContent"
      :categories="props.item.categories"
    )
</template>

<style lang="sass">
.swiper-slide
  height: auto !important
.references-swiper
  .swiper
    padding: 20px 10px
</style>
